"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.borderRadius = void 0;
var borderRadius = '12px';
exports.borderRadius = borderRadius;